import { isEmpty, each, get, replace } from "lodash";
import i18n from '@/i18n';

export default {

  data () {
    return {
      serverErrorAvailable: false,
    };
  },
  methods: {
    validateServerErrorsIfExist: function (validator, response) {
      if (validator && response) {
        if (response.status === 400) {
          this.clearServerErrors(validator);
          this.applyServerErrors(validator, response.data.fieldErrors);
          validator.$reset();
          validator.$touch();
        }
      }
    },
    applyServerErrors: function (validator, fieldErrors) {
      let isAnyServerErrorAvailable = false;
      each(fieldErrors, (item, key) => {
        const field = replace(item.field, '[', '.$each[');
        const fieldError = get(this.$v, field);
        if (!isEmpty(fieldError)) {
          isAnyServerErrorAvailable = true;
          const fieldItemMessage = i18n.t(item.message);
          fieldError['$serverError'] = true;
          fieldError['$serverErrorMessage'] = fieldItemMessage;
          this.applyServerErrorMessage(item.field, fieldItemMessage);
        }
      });
      if (isAnyServerErrorAvailable) {
        this.serverErrorAvailable = isAnyServerErrorAvailable;
        this.highlightFirstErrorIfExist();
      }
    },
    applyServerErrorMessage: function (field, message) {
      const fieldError = get(this.message, field);
      if (!isEmpty(fieldError)) {
        fieldError['serverError'] = message;
      }
    },
    clearServerErrors: function (validator) {
      for (const key in validator) {
        if (validator.hasOwnProperty(key)) {
          if (key === '$serverError') {
            delete validator[key];
          } else if (typeof validator[key] === 'object') {
            this.clearServerErrors(validator[key], '$serverError');
          }
        }
      }
      return validator;
    },
    highlightFirstErrorIfExist: function () {
      setTimeout(function () {
        const fieldErrors = document.getElementsByClassName('is-invalid');
        if (fieldErrors && fieldErrors.length > 0) {
          const inputFields = fieldErrors[0].getElementsByClassName('input');
          if (inputFields && inputFields.length > 0) {
            inputFields[0].scrollIntoView({ behavior: 'smooth' });
            inputFields[0].focus();
          } else {
            fieldErrors[0].focus();
            fieldErrors[0].scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, 1000);
    },
    scrollTo: function (className) {
      setTimeout(function () {
        const fields = document.getElementsByClassName(className);
        if (fields != null && fields.length > 0) {
          const fieldGroupElement = fields[0].getElementsByClassName('form-group');
          fieldGroupElement[0].scrollIntoView({ behavior: 'smooth' });
          const inputFields = fieldGroupElement[0].getElementsByClassName('input');
          if (inputFields != null && inputFields.length > 0) {
            inputFields[0].focus();
          } else {
            fieldGroupElement[0].focus();
          }
        }
      }, 500);
    },
  },
};
